import React from 'react';
import NavBar from '../../components/navbar/navbar';
import {Container, StyledBox, StyledBoxCalendar, StyledCalendar, StyledCarousel} from './styles';
import { Box, Typography, useTheme } from '@mui/material';
import {calendar, homeCards} from '../../utils/data';
import HomeCard from '../../components/homecard/homecard';
import { useNavigate } from 'react-router-dom';
import { User } from '../../models';
import useUser from '../../hooks/useUser';
import { verify } from '../../utils/common';
import CalendarCard from "../../components/calendarcard/calendarcard";

const Home: React.FC = (props) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { setUser } = useUser();

    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    }

    const renderCards = () => {
        return homeCards.map((item) => (
            <HomeCard data={item} handleClick={handleCardClick} />
        ));
    };

    const renderCalendar = () => {
        return calendar.map((item) => (
            <CalendarCard data={item} handleClick={handleCardClick} />
        ));
    }

    React.useEffect(() => {
    (async () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const token = urlParams.get('t');
      if(token){
        localStorage.setItem("jwt",token);
        const tokenInfo = await verify(token);
        if(!tokenInfo.code){
            const userInfo: User = {
                id: tokenInfo.id,
                username: tokenInfo.usuario,
                name: tokenInfo.nombre,
            }
            localStorage.setItem("user", JSON.stringify(userInfo));
            setUser(userInfo);
            navigate("/");
        } else {
            navigate('/unauthorized')
        }
      } else {
        const currentToken = localStorage.getItem("jwt");
        if(currentToken){
            const tokenInfo = await verify(currentToken);
            if(tokenInfo.code){
                localStorage.removeItem("jwt");
                navigate("/unauthorized");
            }
        } else {
            navigate("/unauthorized");
        }
      }
    })()
  },[navigate, setUser]);

    return(
        <Container>
            <NavBar active="inicio"/>
            <Box textAlign="center">
                <StyledBox theme={theme}>
                    {renderCards()}
                </StyledBox>
            </Box>
            <Box m={5}>
                <Typography variant="h5">
                    Calendario de actividades
                </Typography>
                <StyledBoxCalendar theme={theme}>
                    {renderCalendar()}
                </StyledBoxCalendar>

            </Box>

        </Container>
    )
}

export default Home;